// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ArchiveProductTemplatePage from "../templates/ArchiveProductTemplate/ArchiveProductTemplate";
const __wvcRoutePaths = ["/term/product_cat/:term_id", "/term/product_tag/:term_id"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "accueil", "box-du-sommelier", "cart", "cartpage", "checkout", "checkoutpage", "composeyouraperitifpage", "composez-votre-apero", "cuvee-du-patrimoine", "heritageblendpage", "homepage", "kegsandtapspage", "la-cave-du-sommelier", "mariages-evenements", "nouvellepagepage", "plateaux-fondues", "plattersandfonduespage", "post", "raclette-fromages", "racletteandcheesespage", "search", "shop", "shoppage", "soirees-degustations", "sommelierboxpage", "sommeliercellarpage", "term", "tireuses-futs", "weddingsandeventspage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ArchiveProductTemplatePage />} />
      <Route path={__wvcRoutePaths[1]} element={<ArchiveProductTemplatePage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
